const serviceList = (type) => [
  {
    name: "yektanet",
    url: "https://www.yektanet.com",
  },
  {
    name: "panjereh",
    url: "https://panjere.io",
  },
  {
    name: "jaryan",
    url: "https://www.jaryan.net",
  },
  {
    name: "triboon",
    url: "https://www.triboon.net",
  },
  {
    name: "rubika",
    url: "https://socialads.yektanet.com",
  },
  {
    name: "sanjab",
    url: "https://sanjab.co",
  },
  {
    name: "pajva",
    url: "https://www.pajva.net",
  },
  {
    name: "najva",
    url: "https://www.najva.com",
  },
  {
    name: "adivery",
    url: "https://www.adivery.com",
  },
];

export default function(type) {
  return {
    desktop: serviceList(type),
    mobile: serviceList(type),
  }[type];
}
